<template>
  <div class="empty-container" :style="styleObj">
    <img src="~@/assets/images/empty.png" alt="">
    <span>暂无数据</span>
  </div>
</template>

<script>
export default {
  props: {
    styleObj: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.empty-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  img {
    width: 80px
  }
  span {
    color: #cdcdcd;
    margin-top: 10px;
  }
}
</style>